var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_589_13578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 35C27.165 35 35 27.165 35 17.5C35 7.83502 27.165 0 17.5 0C7.83502 0 0 7.83502 0 17.5C0 27.165 7.83502 35 17.5 35Z",
    fill: "#008DE4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2416 7.69873H12.4507L11.7225 11.7709L19.6588 11.7821C23.5675 11.7821 24.7231 13.2014 24.6896 15.5533C24.671 16.7608 24.1509 18.8006 23.9242 19.462C23.3223 21.2231 22.0851 23.2369 17.4481 23.2295L9.73098 23.2258L8.99902 27.3017H17.7713C20.8664 27.3017 22.1817 26.9413 23.575 26.2985C26.6663 24.8718 28.5055 21.8213 29.2411 17.842C30.3409 11.9158 28.9736 7.69873 21.2416 7.69873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.65333 15.4531C6.34972 15.4531 6.01904 16.9542 5.80354 17.8608C5.51745 19.0497 5.42456 19.529 5.42456 19.529H14.4272C16.7308 19.529 17.0615 18.028 17.277 17.1214C17.5631 15.9324 17.656 15.4531 17.656 15.4531H8.65333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_589_13578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/dash.470ef090206668399687ed3f478b719b.svg";
export { ForwardRef as ReactComponent };